// Anti-bot helpers: honeypot field + minimum-time-on-form
const FORM_OPEN_TS_KEY = "_woodies_form_opened";

export const HONEYPOT_NAME = "website_url"; // bots will autofill, humans won't
export const MIN_FILL_TIME_MS = 2500;

export function markFormOpened() {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(FORM_OPEN_TS_KEY, String(Date.now()));
  } catch {
    /* noop */
  }
}

export function getFillTimeMs() {
  if (typeof window === "undefined") return 0;
  try {
    const ts = parseInt(sessionStorage.getItem(FORM_OPEN_TS_KEY) || "0", 10);
    if (!ts) return 0;
    return Date.now() - ts;
  } catch {
    return 0;
  }
}

export function botCheckFailed({ honeypot, fillTimeMs }) {
  if (honeypot && honeypot.trim().length > 0) return "honeypot";
  if (fillTimeMs > 0 && fillTimeMs < MIN_FILL_TIME_MS) return "too-fast";
  return null;
}
